//*** Lib */

import { createCookie, getCookie, isCookieExist, removeAllCookies, removeCookie, setCookie } from "../utils/Cookies/CookieHandler";
import { removeData } from "../utils/LocalStorage/LocalStorageManager";
import { useEffect,useRef } from "react";
const authCookieName = 'SGBCAdminAuthUser';
const tokenCookieName = 'SGBCToken';
const securityPermission = 'SecurityPermission';

export const setAuthProps = (data) => {
    const authProps = {
        cookieName: authCookieName,
        cookieValue: data,
        expirationTime: data.sessionTimeout
    }
    createCookie(authProps);
    setTokenProps(data.token);
}

export const setSecurityPermission = (data, sessionTimeout) => {
    const authProps = {
        cookieName: securityPermission,
        cookieValue: data,
        expirationTime: sessionTimeout
    }
    createCookie(authProps);
}

export const getAuthProps = () => {
    return getCookie(authCookieName);
}

export const isAuthorized = () => {
    return isCookieExist(authCookieName);
}

export const setTokenProps = (data) => {
    const tokenProps = {
        cookieName: tokenCookieName,
        cookieValue: data
    }
    setCookie(tokenProps);
}

export const getTokenProps = () => {
    return getCookie(tokenCookieName);
}

export const signOut = () => {
    removeCookie(authCookieName, { path: '/' });
    removeCookie(tokenCookieName, { path: '/' });
    // removeAllCookies();
    //sessionStorage.removeItem('SecurityPermission');
    // removeData("SecurityPermission")
    window.location.href = "/login";
}
export const useInactivityDetector = (timeout) => {
    const timerRef = useRef(null);
  
    useEffect(() => {
      const resetTimer = () => {
        clearTimeout(timerRef.current);
  
        timerRef.current = setTimeout(() => {
          signOut();
        }, timeout);
      };
  
      const events = [
        "mousemove",
        "keydown",
        "click",
        "scroll",
        "touchstart"
      ];
  
      events.forEach(event =>
        window.addEventListener(event, resetTimer)
      );
  
      resetTimer();
  
      return () => {
        clearTimeout(timerRef.current);
        events.forEach(event =>
          window.removeEventListener(event, resetTimer)
        );
      };
    }, [timeout]);
  };